var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconWhiteOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67007 5.33659C8.67007 5.70478 8.37159 6.00326 8.0034 6.00326H7.99673C7.62854 6.00326 7.33006 5.70478 7.33006 5.33659C7.33007 4.9684 7.62854 4.66992 7.99673 4.66992L8.0034 4.66992C8.37159 4.66992 8.67007 4.9684 8.67007 5.33659Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99668 11.67C7.62849 11.67 7.33002 11.3715 7.33002 11.0033L7.33002 7.67C7.33002 7.30181 7.62849 7.00334 7.99668 7.00334C8.36487 7.00334 8.66335 7.30181 8.66335 7.67L8.66335 11.0033C8.66335 11.3715 8.36487 11.67 7.99668 11.67Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconWhiteOut);
export default __webpack_public_path__ + "static/media/InfoIconWhiteOut.e88f9e1b.svg";
export { ForwardRef as ReactComponent };